import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { GuestList } from 'reservations/guests/components/GuestList';

export const ManageGuestsModal = () => (
  <BaseDrawer header="Manage guests" requireAuth>
    <GuestList />
  </BaseDrawer>
);
